/* eslint-disable yola/react/require-default-props */
import React, { forwardRef } from 'react';
import BaseSelect from '../base-select';
import { APPEARANCES, SIZES } from '../base-select/constants';
import LoadingIndicator from './loading-indicator';
import noop from '../../../utils/noop';

const MultiSelect = forwardRef(
  (
    {
      size = SIZES.small,
      id = undefined,
      name = undefined,
      placeholder = '',
      noResultsText = '',
      options,
      defaultValue = undefined,
      value = undefined,
      clearable = false,
      disabled = false,
      invalid = false,
      preventOverflow = false,
      onChange,
      onBlur = noop,
      onFocus = noop,
      onInputChange = noop,
      openMenuOnFocus = false,
      filterOptionsFunction = undefined,
      asyncConfig = null,
      menuPlacement = 'auto',
      maxMenuHeight = undefined,
      components = undefined,
    },
    ref
  ) => {
    const defaultComponents = asyncConfig ? { LoadingIndicator } : undefined;
    const searchableComponents = components || defaultComponents;

    return (
      <BaseSelect
        isMulti
        ref={ref}
        appearance={APPEARANCES.searchable}
        size={size}
        asyncConfig={asyncConfig}
        withDropdownIndicator
        components={searchableComponents}
        id={id}
        name={name}
        placeholder={placeholder}
        noResultsText={noResultsText}
        options={options}
        defaultValue={defaultValue}
        value={value}
        clearable={clearable}
        disabled={disabled}
        invalid={invalid}
        preventOverflow={preventOverflow}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        onInputChange={onInputChange}
        openMenuOnFocus={openMenuOnFocus}
        filterOptionsFunction={filterOptionsFunction}
        menuPlacement={menuPlacement}
        maxMenuHeight={maxMenuHeight}
      />
    );
  }
);

MultiSelect.displayName = 'MultiSelect';

export default MultiSelect;
